import { Config } from '../model';

export const config: Config = {
  gatekeeperUrl: 'https://gatekeeper.theboapi.net',
  url: 'https://web.theboapi.net',
  oneTrustKey: '639a5c55-019a-43e1-a687-efbee680c9ec',
};
